import { Box } from '../../primitives';
import { styled } from '../../theme';
import { Heading } from '../Heading';

export const Wrapper = styled(Box)<{ noIndent?: boolean }>`
	display: grid;
	grid-template-columns: auto 1fr;
	grid-template-areas:
		'bullet heading'
		'${({ noIndent }) => (noIndent ? 'content' : 'blank')} content';
	padding: 0 ${({ theme }) => theme.space.md}px ${({ theme }) => theme.space.md}px;

	@media ${({ theme }) => theme.device.tablet} {
		padding: 0 ${({ theme }) => theme.space.lg}px ${({ theme }) => theme.space.md}px;
	}
`;

export const Bullet = styled(Box)`
	grid-area: bullet;

	border-radius: 50px;
	width: 16px;
	height: 16px;
	background-color: ${({ theme }) => theme.color.green.base};
	margin: 18px ${({ theme }) => theme.space.md}px 0 0;
`;

export const HeadingText = styled(Heading).attrs((props) => ({
	...props,
	level: 4,
}))`
	grid-area: heading;
`;

export const Content = styled(Box)`
	grid-area: content;
`;
